<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list" class="p-1 mb-0"/>
        <div class="container-fluid p-1">
          <router-view></router-view>
           <beautiful-chat :key="index" v-for = "(windown,index) in windownChats"
            :right="index*310 + 10 + ''"
            :participants="windown.participants"
            :titleImageUrl="windown.participants[0].imageUrl"
            :onMessageWasSent="sendMessage.bind(null, windown)"
            :messageList="windown.messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="windown.is_open"
            :close="closeChat.bind(null, windown)"
            :open="openChat"
            :showEmoji="true"
            :showFile="true"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom" />
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
    <back-to-top :custom-style="myBackToTopStyle" :visibility-height="300" :back-position="50" transition-name="fade"/>
  </div>
</template>

<script>
// import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb, BackToTop } from '../components/layout/index'
export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    BackToTop
  },
  data () {
    return {
      myBackToTopStyle: {
        right: '50px',
        bottom: '50px',
        width: '40px',
        height: '40px',
        'border-radius': '4px',
        'line-height': '45px', // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: '#5488c7'// 按钮的背景颜色 The background color of the button
      },
      // messageList: [
      //     { type: 'text', author: `me`, data: { text: `Say yes!` } },
      //     { type: 'text', author: `user1`, data: { text: `No.` } }
      // ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      // isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false
    }
  },
  computed: {

    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    nav () {
      // if(this.$store.getters['Profile/getGroup'].id === 1) {
      //   return nav.items
      // }
      return this.$store.getters['Menu/getMenu']
    },
    windownChats () {
      return this.$store.getters['Chat/getWindownChats']
    }
  },
  mounted () {
    this.$store.dispatch('Menu/getMenu').then(res => {

    }).catch(errors => {

    })
  },
  methods: {
    sendMessage (windown, text) {
      if (windown.chanel_id === 0) {
        this.$store.dispatch('Chat/chatSystem', {chanel_id: windown.chanel_id, message: text, user: {id: windown.chanel_id}})
        return false
      }
      this.$store.dispatch('Chat/sendMessage', {chanel_id: windown.chanel_id, message: text, user: {id: windown.chanel_id}})
    },
    openChat () {
      this.$store.dispatch('Chat/openChat')
      this.newMessagesCount = 0
    },
    closeChat (chanel_id = {}) {
      this.$store.dispatch('Chat/closeChat', chanel_id.chanel_id)
    }
  }
}
</script>

<style>
  .form-control {
    border-radius: .25rem;
  }
  .link {
    color : rgb(32, 168, 216)
  }
  .link:hover {
    cursor: pointer;
    text-decoration-line: underline;
  }
  .ck-editor__editable {
    min-height: 200px;
  }

  .scroll {
    max-height: 100vh;
    overflow: auto;
  }

  .scroll-notification {
     max-height: 70vh;
     overflow: auto;
     width: 40vw;
  }

  .red {
    background: rgb(235, 77, 77) !important;
    color: whitesmoke !important;
  }
  .blue {
    background: rgb(59, 59, 163) !important;
    color: whitesmoke !important;
  }
  .orange {
    cursor: pointer;
    background: orange !important;
    color: white !important;
  }
  .green {
    cursor: pointer;
    background: #20a8d8 !important;
    color: white !important;
  }

  .events-week {
    height: 102px;
  }

  .today .cv-day-number {
    background-color: aqua !important
  }

.lds-facebook {
  display: inline-block;
  position: relative;
  width: 32px;
  height: 32px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 10px;
  background: #dddddd;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 6px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 26px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 45px;
  animation-delay: 0;
}
@keyframes lds-facebook {
  0% {
    top: 6px;
    height: 51px;
  }
  50%, 100% {
    top: 19px;
    height: 26px;
  }
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #dddddd;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

body.app.header-fixed.sidebar-fixed.aside-menu-fixed.breadcrumb-fixed {
  font-size: 0.80rem;
}

/* Css of tab chat */
/* img.sc-header--img {
    width: 12%;
    padding: 5px!important;
}
.sc-header {
    padding: 5px!important;
    min-height: 50px!important;
}
.sc-header--title {
    padding: 0px!important;
}
.sc-header--close-button {
    width: 25px;
    height: 25px;
}
.sc-chat-window.opened {
    width: 310px!important;
    max-height: 420px!important;
}
.sc-launcher {
    width: 40px;
    height: 40px;
}
.sc-launcher .sc-open-icon{
    padding: 10px;
}
.sc-launcher .sc-open-icon[data-v-01310535], .sc-launcher .sc-closed-icon[data-v-01310535] {
    width: 40px;
    height: 40px;
}
.sc-launcher{
    width: 40px;
    height: 40px;
}
.sc-chat-window.opened {
    z-index: 1;
} */
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue